import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import ProtectedRoute from "../components/ProtectedRoute";
import PublicLayout from "../layouts/PublicLayout";
import DashboardLayout from "../layouts/DashboardLayout";
import HomePage from "../pages/HomePage";
import AboutPage from "../pages/AboutPage";
import CounterPage from "../pages/CounterPage";
import DashboardPage from "../pages/DashboardPage";
import AssetDetailPage from "../pages/AssetDetailPage";
import SettingsPage from "../pages/SettingsPage";
import NotFoundPage from "../pages/NotFoundPage";
import PositionsPage from "../pages/PositionsPage";
import OrdersPage from "../pages/OrdersPage";
import WatchlistPage from "../pages/WatchlistPage";
import MarketsPage from "../pages/MarketsPage";
import CaptinAiPage from "../pages/CaptinAiPage";
import DiscoverPage from "../pages/DiscoverPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <PublicLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "counter",
        element: (
          <ProtectedRoute>
            <CounterPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "settings",
        element: (
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "positions",
        element: (
          <ProtectedRoute>
            <PositionsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "orders",
        element: (
          <ProtectedRoute>
            <OrdersPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "watchlist",
        element: (
          <ProtectedRoute>
            <WatchlistPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "markets",
        element: (
          <ProtectedRoute>
            <MarketsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "captin-ai",
        element: (
          <ProtectedRoute>
            <CaptinAiPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "discover",
        element: (
          <ProtectedRoute>
            <DiscoverPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "login",
        element: <LoginPage />,
      },
      {
        path: "dashboard",
        element: (
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: <DashboardPage />,
          },
          {
            path: "asset/:marketAssetId",
            element: <AssetDetailPage />,
          },
        ],
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);

export const Router = () => <RouterProvider router={router} />;

export default Router;
